import { messaging } from '@/configs/firebaseConfig'
import { ENV } from '@/constants/env'
import { useUserStore } from '@/store/useUserStore'
import { isSupported, onMessage } from 'firebase/messaging'
import {
  safeNotificationInstance,
  subsribeNotificationToServer,
} from '@/utils/helpers/notification'
import { getToken } from 'firebase/messaging'
import { useEffect } from 'react'
import { App, Button } from 'antd'
import { QUERY_KEY_APPOINTMENT_ITEMS } from '../appointment/useGetAppointmentItems'
import { queryClient } from '@/configs/tanstack'

export const useGetNotificationPermission = () => {
  const { profile } = useUserStore()
  const { notification } = App.useApp()
  const requestPermission = async () => {
    if (typeof window === 'undefined') return
    if (!('Notification' in window))
      return console.warn('Notification API not supported')
    if (!('serviceWorker' in navigator))
      return console.warn('Service Worker not supported')
    const permission = await safeNotificationInstance?.requestPermission()
    if (permission === 'granted') {
      if (await isSupported()) {
        const token = await getToken(messaging, {
          vapidKey: ENV.VITE_APP_VAPID_KEY,
        })
        subsribeNotificationToServer(token)
      }
    } else if (permission === 'denied') {
      alert('You denied for the notification')
    }
  }
  useEffect(() => {
    if (profile) {
      requestPermission()
    }
  }, [profile])

  useEffect(() => {
    // Listen for foreground messages (when the tab is in focus)
    const unsubscribeForegroundMessage = onMessage(
      messaging,
      (payload: {
        data?: { url?: string }
        notification?: {
          body?: string
          title?: string
        }
      }) => {
        const currentUrl = `${window.location.origin}${window.location.pathname}`
        queryClient.invalidateQueries({
          queryKey: [QUERY_KEY_APPOINTMENT_ITEMS],
        })
        if (currentUrl !== payload.data?.url) {
          notification.info({
            title: payload?.notification?.title,
            description: payload?.notification?.body,
            showProgress: true,
            pauseOnHover: true,
            actions: (
              <Button type="link" href={payload.data?.url || ''} size="middle">
                Check the appointment
              </Button>
            ),
          })
        }
      },
    )

    // Clean up listeners when the component unmounts
    return () => {
      unsubscribeForegroundMessage()
    }
  }, [])
}
